export default __webpack_public_path__ + "static/media/gu.cb9e47f0.svg";